import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import { HotTable } from '@handsontable/react';
import * as SpaceActionCreators from '../../ducks/spaces';

class SpaceImporterModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tableContent: [[]],
            importing: false,
            justImported: false,
            show: false,
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({ show: props.show });
    }

    toggle = () => {
        let hiding = this.state.show;
        this.setState({ show: !this.state.show });

        if(hiding && typeof this.props.onHide === 'function')
            this.props.onHide();
    }

    handleTableChange = (event, source) => {
        if(!event) {
            return;
        }

        let tableContent = this.state.tableContent;

        event.map((change) => {
            let i = change[0];
            let j = change[1];

            if(!tableContent[i]) {
                tableContent[i] = [];
            }

            tableContent[i][j] = change[3];

            return null;
        });

        this.setState({ tableContent: tableContent });
    }

    structureSpaceObjects = (tableContent) => {
        return tableContent.map((row) => {
            return {
                asset_name: row[0],
                space_name: row[1],
                space_code: row[2],
                total_size: row[3],
                common_size: row[4],
                usage_numeraire: row[5],
                usage_denominator: row[6]
            };
        });
    }

    currentFy = () => {
        return this.props.puCalcFy && this.props.puCalcFy !== 'latest' ? this.props.puCalcFy : this.props.client.pu_fys[0];
    }

    hasSpacesInTable = () => {
        return this.state.tableContent.length > 0 && this.state.tableContent[0].length > 0;
    }

    importSpaces = () => {
        if(this.hasSpacesInTable() && !this.state.importing) {
            this.setState({ importing: true });

            this.props
                .importSpaces({
                    client_id: this.props.client.client_id,
                    spaces: this.structureSpaceObjects(this.state.tableContent),
                    inputData: this.state.tableContent,
                })
                .then(() => {
                    this.setState({ importing: false, justImported: true });
                    this.toggle();
                    if (typeof this.props.onHide === 'function') {
                        this.props.onHide();
                    }
                })
                .catch((error) => {
                    this.setState({ importing: false });
                    alert(error);
                });
        }
    }

    clearForm = () => {
        this.setState({
            tableContent: [[]],
            importing: false,
            justImported: false,
        });
    }

    render() {
        const numeraireOptions = this.props.numeraires.map((numeraire) => {
            return numeraire.symbol;
        });

        return (
            <Modal isOpen={this.state.show} toggle={this.toggle} className="modal-xl" backdrop="static">
                <ModalHeader toggle={this.toggle}>
                    <span className="font-weight-bold">Import Spaces</span>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <div style={{height: '550px', overflowY: 'hidden'}}>
                                <HotTable
                                    root={ "hotImportUses" }
                                    data={ this.state.tableContent }
                                    contextMenu={true}
                                    columns={[
                                        { type: 'text', width: 130 },
                                        { type: 'text', width: 130 },
                                        { type: 'text', width: 100 },
                                        { type: 'numeric', numericFormat: { pattern: '0,0' }, correctFormat: true, className: "htRight", width: 120 },
                                        { type: 'numeric', numericFormat: { pattern: '0,0' }, correctFormat: true, className: "htRight", width: 120 },
                                        { type: 'dropdown', source: numeraireOptions, width: 140 },
                                        { type: 'numeric', numericFormat: { pattern: '0,0' }, correctFormat: true, className: "htRight", width: 150 },
                                    ]}
                                    colHeaders={[
                                        'Asset Name or Code',
                                        'Space Name',
                                        'Space Code',
                                        'Total Size (opt.)',
                                        'Common Size (opt.)',
                                        'Usage Numeraire (opt.)',
                                        'Usage Denominator (opt.)'
                                    ]}
                                    rowHeaders={ true }
                                    minRows={ 20 }
                                    afterChange={this.handleTableChange} />
                            </div>
                        </div>
                    </div>
                    <div className="text-right">
                        {
                            this.hasSpacesInTable()
                                ? (<button className="btn btn-success rounded-0" onClick={this.importSpaces}>
                                    {
                                        this.state.importing
                                            ? 'Importing...'
                                            : 'Import Spaces'
                                    }
                                </button>)
                                : '' 
                        }
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

SpaceImporterModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
};

const mapStateToProps = state => (
    {
        client: state.client.client,
        puCalcFy: state.client.puCalcFy,
        numeraires: state.numeraires.numeraires
    }
);

const mapDispatchToProps = dispatch => {
    return {
        importSpaces: (importData) => dispatch(SpaceActionCreators.importStructured(importData)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SpaceImporterModal);